module.exports = __webpack_public_path__ + "img/GI.4217c0d8.svg";